module.exports = __webpack_public_path__ + "static/media/ph.0394a95d.svg";